define(["angular", "angular-animate", "angular-bootstrap", "angular-translate"], function (angular) {
    "use strict";

    return angular.module("violationModule",  ["ngAnimate", "ui.bootstrap", "pascalprecht.translate"]);
});